import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTenant } from '../contexts/TenantContext';

const BASE = process.env.REACT_APP_BACKEND_URL || '';
const DEFAULT_ICON = '/brand/logo.png';

/**
 * Dynamic PWA manifest — Option (b).
 * After TenantContext loads, injects a <link rel="manifest"> with the tenant's
 * brand logo and business name so "Add to Home Screen" shows the custom icon.
 */
export function useDynamicManifest() {
  const { tenant } = useAuth();
  const { brand } = useTenant();

  useEffect(() => {
    const name = tenant?.name || '1000AD';
    const shortName = name.length > 12 ? name.slice(0, 12) : name;

    let iconSrc = DEFAULT_ICON;
    if (brand?.brand_logo_url && tenant?.id) {
      const v = brand.brand_logo_updated_at || '';
      iconSrc = `${BASE}/api/brand/${tenant.id}/logo${v ? `?v=${encodeURIComponent(v)}` : ''}`;
    }

    const manifest = {
      short_name: shortName,
      name: `${name} — AI Business Manager`,
      icons: [
        { src: iconSrc, sizes: '192x192', type: 'image/png', purpose: 'any maskable' },
        { src: iconSrc, sizes: '512x512', type: 'image/png', purpose: 'any maskable' },
      ],
      start_url: '/home',
      display: 'standalone',
      theme_color: '#0B1220',
      background_color: '#0B1220',
    };

    const blob = new Blob([JSON.stringify(manifest)], { type: 'application/manifest+json' });
    const url = URL.createObjectURL(blob);

    // Remove any existing manifest link
    const existing = document.querySelector('link[rel="manifest"]');
    if (existing) existing.remove();

    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = url;
    document.head.appendChild(link);

    return () => {
      link.remove();
      URL.revokeObjectURL(url);
    };
  }, [tenant?.id, tenant?.name, brand?.brand_logo_url, brand?.brand_logo_updated_at]);
}
